import sample_1 from './sample1.jpeg';

export const epaImpressions = {
    sample_1,
};
